// extracted by mini-css-extract-plugin
export default {"assignmentListItem":"assignmentList_assignmentListItem__azYeN","linkStrike":"assignmentList_linkStrike__AVVpO"};